// English phrases are stable message keys. Translate complete phrases, preserving named placeholders.
export const en = {
  " Car": " Car",
  " Contests": " Contests",
  " Drivers": " Drivers",
  " Join": " Join",
  " Menu": " Menu",
  " Season": " Season",
  "21 unique drivers with different driving styles": "21 unique drivers with different driving styles",
  "6 Mbps": "6 Mbps",
  "A Free To Play casual racing game where you pick two aliens and a car.": "A Free To Play casual racing game where you pick two aliens and a car.",
  "A quick surge of speed, but can be dangerous!": "A quick surge of speed, but can be dangerous!",
  "Abilities": "Abilities",
  "Accel": "Accel",
  "Actions": "Actions",
  "Adoring Fans": "Adoring Fans",
  "Advanced: Stream via OBS": "Advanced: Stream via OBS",
  "After the first race, the leaderboard will be updated upon refresh.": "After the first race, the leaderboard will be updated upon refresh.",
  "Airstrike": "Airstrike",
  "All Players ({value0})": "All Players ({value0})",
  "An error occurred": "An error occurred",
  "An error occurred while updating display name.": "An error occurred while updating display name.",
  "Angry": "Angry",
  "Atomic": "Atomic",
  "Attack your opponents and knock them off the road!": "Attack your opponents and knock them off the road!",
  "Avg Pos": "Avg Pos",
  "Awooga": "Awooga",
  "BINGO!": "BINGO!",
  "BINGO! 🎰 Claim Prize": "BINGO! 🎰 Claim Prize",
  "BOOST": "BOOST",
  "Battlepass Reward!": "Battlepass Reward!",
  "Be the first to host a game!": "Be the first to host a game!",
  "Beaky": "Beaky",
  "Bearer Token:": "Bearer Token:",
  "Best Time": "Best Time",
  "Best Win Streak": "Best Win Streak",
  "Best quality, high bandwidth": "Best quality, high bandwidth",
  "Bingo": "Bingo",
  "Biohazard": "Biohazard",
  "Bitrate:": "Bitrate:",
  "Black Hole": "Black Hole",
  "Blue": "Blue",
  "Blue Horse": "Blue Horse",
  "Blue Lightning": "Blue Lightning",
  "Boards are created automatically when you participate": "Boards are created automatically when you participate",
  "Boost": "Boost",
  "Boost (1)": "Boost (1)",
  "Boost 10 times": "Boost 10 times",
  "Boost Trail": "Boost Trail",
  "Boost Trails": "Boost Trails",
  "Boost {goal} times": "Boost {goal} times",
  "Booster": "Booster",
  "Boosters": "Boosters",
  "Boosting": "Boosting",
  "Boosts Used": "Boosts Used",
  "Bottle Spray": "Bottle Spray",
  "Bowling Ball": "Bowling Ball",
  "Brake": "Brake",
  "Brake (4)": "Brake (4)",
  "Brakes Used": "Brakes Used",
  "Break check into 10 cars": "Break check into 10 cars",
  "Bugle": "Bugle",
  "Bunny Hop": "Bunny Hop",
  "CARS": "CARS",
  "Cancel": "Cancel",
  "Candy Horn": "Candy Horn",
  "Car": "Car",
  "Car Jump": "Car Jump",
  "Celebration": "Celebration",
  "Celebrations": "Celebrations",
  "Change Name": "Change Name",
  "Characters": "Characters",
  "Chat": "Chat",
  "Check back later!": "Check back later!",
  "Check for active stream": "Check for active stream",
  "Cherry Blossoms": "Cherry Blossoms",
  "Choose from a selection of 10 vehicles": "Choose from a selection of 10 vehicles",
  "Chrome": "Chrome",
  "Circus Cannon": "Circus Cannon",
  "Claim": "Claim",
  "Claim all daily quests": "Claim all daily quests",
  "Claiming reward...": "Claiming reward...",
  "Click the button above and share your game window - it's that easy!": "Click the button above and share your game window - it's that easy!",
  "Close": "Close",
  "Close notification": "Close notification",
  "Codex": "Codex",
  "Combos": "Combos",
  "Complete a race to see your stats!": "Complete a race to see your stats!",
  "Complete races to see standings!": "Complete races to see standings!",
  "Complete the Twitch sign-in to finish linking.": "Complete the Twitch sign-in to finish linking.",
  "Completing login, please wait...": "Completing login, please wait...",
  "Confused": "Confused",
  "Connected": "Connected",
  "Connecting...": "Connecting...",
  "Contests": "Contests",
  "Contests (0)": "Contests (0)",
  "Continue as Guest": "Continue as Guest",
  "Copy the settings above into OBS, then press Start Stream in OBS.": "Copy the settings above into OBS, then press Start Stream in OBS.",
  "Create Your Lobby": "Create Your Lobby",
  "Crying": "Crying",
  "Current": "Current",
  "Customise your vehicles with a variety of cosmetic upgrades!": "Customise your vehicles with a variety of cosmetic upgrades!",
  "Customize Car": "Customize Car",
  "Customize Car (7)": "Customize Car (7)",
  "Customize Driver & Passenger": "Customize Driver & Passenger",
  "Customize Drivers (8)": "Customize Drivers (8)",
  "Customize {value0}": "Customize {value0}",
  "DRIVERS": "DRIVERS",
  "Daily quests reset at {value0}{value1}": "Daily quests reset at {value0}{value1}",
  "Damage Dealt": "Damage Dealt",
  "Damage Shielded": "Damage Shielded",
  "Damage Taken": "Damage Taken",
  "Dance": "Dance",
  "Decal": "Decal",
  "Decals": "Decals",
  "Did Not Finish": "Did Not Finish",
  "Disconnected due to inactivity": "Disconnected due to inactivity",
  "Display name cannot be empty": "Display name cannot be empty",
  "Do 1,000 damage to other cars": "Do 1,000 damage to other cars",
  "Do 1000 damage": "Do 1000 damage",
  "Do {goal} damage": "Do {goal} damage",
  "Done": "Done",
  "Door": "Door",
  "Drag to rotate": "Drag to rotate",
  "Drift": "Drift",
  "Driver": "Driver",
  "Driver Radio": "Driver Radio",
  "Driver Special (Q)": "Driver Special (Q)",
  "Driver {value0}": "Driver {value0}",
  "Drivers": "Drivers",
  "Driving": "Driving",
  "E": "E",
  "Earthquake": "Earthquake",
  "Emote": "Emote",
  "Emote (E)": "Emote (E)",
  "Emotes": "Emotes",
  "Enable your microphone to speak with others": "Enable your microphone to speak with others",
  "Encoder:": "Encoder:",
  "FREE": "FREE",
  "Failed to connect to HD stream": "Failed to connect to HD stream",
  "Failed to link account": "Failed to link account",
  "Failed to load car": "Failed to load car",
  "Failed to load leaderboard": "Failed to load leaderboard",
  "Failed to start HD stream": "Failed to start HD stream",
  "Failed to update display name. Please try again.": "Failed to update display name. Please try again.",
  "Fastest Race": "Fastest Race",
  "Fastest Time": "Fastest Time",
  "Finish 100 races - Level 3 Complete!": "Finish 100 races - Level 3 Complete!",
  "Finish Rate": "Finish Rate",
  "Finish in 5 races": "Finish in 5 races",
  "Finish {goal} races": "Finish {goal} races",
  "Fireball": "Fireball",
  "First X Races:": "First X Races:",
  "First {value0} Races": "First {value0} Races",
  "Flaming Skull": "Flaming Skull",
  "Flex": "Flex",
  "Forest": "Forest",
  "Galaxy": "Galaxy",
  "Galaxy Paint added to your inventory": "Galaxy Paint added to your inventory",
  "Garage": "Garage",
  "Generate OBS Settings": "Generate OBS Settings",
  "Ghost": "Ghost",
  "Glow": "Glow",
  "Good quality, low bandwidth": "Good quality, low bandwidth",
  "Green": "Green",
  "Growth Potion": "Growth Potion",
  "Guess": "Guess",
  "Guest username": "Guest username",
  "Handling": "Handling",
  "Happy": "Happy",
  "Hat": "Hat",
  "Hats": "Hats",
  "Health": "Health",
  "High quality": "High quality",
  "Higher Quality with OBS": "Higher Quality with OBS",
  "Hold to Talk": "Hold to Talk",
  "Hold {value0} to talk": "Hold {value0} to talk",
  "Home": "Home",
  "Hood": "Hood",
  "Horn": "Horn",
  "Horn (R)": "Horn (R)",
  "Horns": "Horns",
  "Horny": "Horny",
  "Host": "Host",
  "Host a Live Lobby": "Host a Live Lobby",
  "How it works:": "How it works:",
  "How to Play": "How to Play",
  "IVS WHIP supports max 720p. Set Output Resolution in Settings > Video. Requires OBS v30+.": "IVS WHIP supports max 720p. Set Output Resolution in Settings > Video. Requires OBS v30+.",
  "Impulse": "Impulse",
  "Initializing...": "Initializing...",
  "Invite Players": "Invite Players",
  "Join": "Join",
  "Join Race (6)": "Join Race (6)",
  "Join a race to get your bingo board!": "Join a race to get your bingo board!",
  "Just now": "Just now",
  "Ketchup & Mustard": "Ketchup & Mustard",
  "Keyframe Interval:": "Keyframe Interval:",
  "Last Time:": "Last Time:",
  "Leaderboard": "Leaderboard",
  "League Not Started": "League Not Started",
  "Leave": "Leave",
  "Level {level} Unlocked!": "Level {level} Unlocked!",
  "Level {level} reward is ready to claim!": "Level {level} reward is ready to claim!",
  "Level {value0}": "Level {value0}",
  "Link Twitch": "Link Twitch",
  "Linking...": "Linking...",
  "Loaded Dice": "Loaded Dice",
  "Loading OBS settings...": "Loading OBS settings...",
  "Loading all-time stats...": "Loading all-time stats...",
  "Loading bingo...": "Loading bingo...",
  "Loading car model...": "Loading car model...",
  "Loading car...": "Loading car...",
  "Loading combo stats...": "Loading combo stats...",
  "Loading leaderboard...": "Loading leaderboard...",
  "Loading profile...": "Loading profile...",
  "Loading...": "Loading...",
  "Lobbies": "Lobbies",
  "Locusts": "Locusts",
  "Log In": "Log In",
  "Logging in, please wait...": "Logging in, please wait...",
  "Login": "Login",
  "Login to Start Hosting": "Login to Start Hosting",
  "Login with Twitch": "Login with Twitch",
  "Logout": "Logout",
  "Lv {value0}": "Lv {value0}",
  "Lv. {value0}": "Lv. {value0}",
  "Lv.{value0} • {value1}/1000": "Lv.{value0} • {value1}/1000",
  "Mach 55": "Mach 55",
  "Magnet": "Magnet",
  "Mark all read": "Mark all read",
  "Matrix": "Matrix",
  "Meow": "Meow",
  "Microphone access denied. Check browser permissions to enable commentary.": "Microphone access denied. Check browser permissions to enable commentary.",
  "Microphone {value0}": "Microphone {value0}",
  "Milestone Reached!": "Milestone Reached!",
  "Milestones": "Milestones",
  "Monochrome": "Monochrome",
  "Monster": "Monster",
  "Morale": "Morale",
  "Most DNF": "Most DNF",
  "Mute": "Mute",
  "My Board": "My Board",
  "My Stats": "My Stats",
  "Name": "Name",
  "Need 5+ races with same duo": "Need 5+ races with same duo",
  "New Item!": "New Item!",
  "New season reward available - tap to claim!": "New season reward available - tap to claim!",
  "No Changes": "No Changes",
  "No Microphone (system audio only)": "No Microphone (system audio only)",
  "No commands queued": "No commands queued",
  "No duo data yet": "No duo data yet",
  "No items in inventory": "No items in inventory",
  "No leaderboard data yet": "No leaderboard data yet",
  "No live lobbies right now": "No live lobbies right now",
  "No messages yet": "No messages yet",
  "No microphones found": "No microphones found",
  "No notifications yet": "No notifications yet",
  "No one is connected yet": "No one is connected yet",
  "No one is currently streaming Nova Rally on Twitch.": "No one is currently streaming Nova Rally on Twitch.",
  "No players have boards yet": "No players have boards yet",
  "No race data found for \"{value0}\"": "No race data found for \"{value0}\"",
  "No race results yet": "No race results yet",
  "No races on {value0} yet. Try \"All Time\"!": "No races on {value0} yet. Try \"All Time\"!",
  "None": "None",
  "Not connected to the network!": "Not connected to the network!",
  "Not linked": "Not linked",
  "Notification": "Notification",
  "Nova Ballet": "Nova Ballet",
  "Nova Rally": "Nova Rally",
  "Now level {level}!": "Now level {level}!",
  "OBS Setup (v30+):": "OBS Setup (v30+):",
  "OFF": "OFF",
  "OK": "OK",
  "ON": "ON",
  "Offline": "Offline",
  "Online": "Online",
  "Ooze Slime": "Ooze Slime",
  "Output Resolution:": "Output Resolution:",
  "Overall Leaderboard": "Overall Leaderboard",
  "PTT {value0}": "PTT {value0}",
  "Paint": "Paint",
  "Participants ({value0})": "Participants ({value0})",
  "Party Hat": "Party Hat",
  "Passenger": "Passenger",
  "Passenger Special (W)": "Passenger Special (W)",
  "Phoenix": "Phoenix",
  "Play": "Play",
  "Play Now": "Play Now",
  "Play on": "Play on",
  "Players": "Players",
  "Players join and use the game controls to compete in your races!": "Players join and use the game controls to compete in your races!",
  "Please log in before linking accounts.": "Please log in before linking accounts.",
  "Please log in to see your stats": "Please log in to see your stats",
  "Please log in to start a stream": "Please log in to start a stream",
  "Please login to participate": "Please login to participate",
  "Please login to play": "Please login to play",
  "Please login to play.": "Please login to play.",
  "Podium 3 times": "Podium 3 times",
  "Podium Rate": "Podium Rate",
  "Points": "Points",
  "Polygon": "Polygon",
  "Pre-Alpha Tester": "Pre-Alpha Tester",
  "Privacy Policy": "Privacy Policy",
  "Processing login, please wait...": "Processing login, please wait...",
  "Protect yourself from damage for a few seconds": "Protect yourself from damage for a few seconds",
  "Purple": "Purple",
  "Q": "Q",
  "Quality": "Quality",
  "Quest Complete!": "Quest Complete!",
  "Quests": "Quests",
  "R": "R",
  "RAM": "RAM",
  "Race Finishes (Last {value0})": "Race Finishes (Last {value0})",
  "Race Together!": "Race Together!",
  "Race with {car} 3x": "Race with {car} 3x",
  "Race with {driver} 5x": "Race with {driver} 5x",
  "Race {value0}": "Race {value0}",
  "Races": "Races",
  "Ram": "Ram",
  "Ram (2)": "Ram (2)",
  "Ram into 10 cars": "Ram into 10 cars",
  "Ram into {goal} opponents": "Ram into {goal} opponents",
  "Ramming": "Ramming",
  "Rams": "Rams",
  "Rams Used": "Rams Used",
  "Random": "Random",
  "Rank": "Rank",
  "Re-authenticating, please wait...": "Re-authenticating, please wait...",
  "Reach Level {value0}": "Reach Level {value0}",
  "Reach level {value0} to unlock more rewards.": "Reach level {value0} to unlock more rewards.",
  "Red": "Red",
  "Refresh season data": "Refresh season data",
  "Refresh stream status": "Refresh stream status",
  "Refreshing profile...": "Refreshing profile...",
  "Refreshing...": "Refreshing...",
  "Regen": "Regen",
  "Relink Twitch": "Relink Twitch",
  "Reward": "Reward",
  "Rewards": "Rewards",
  "SHIELD": "SHIELD",
  "Sammy Baffled": "Sammy Baffled",
  "Save": "Save",
  "Screen Share": "Screen Share",
  "Season": "Season",
  "Season 2 ends in {value0}d {value1}h": "Season 2 ends in {value0}d {value1}h",
  "Season Pass (9)": "Season Pass (9)",
  "Season Points": "Season Points",
  "Select Car": "Select Car",
  "Select Driver": "Select Driver",
  "Select Passenger": "Select Passenger",
  "Select a League": "Select a League",
  "Select your mic for voice commentary. System audio from the shared window is always included.": "Select your mic for voice commentary. System audio from the shared window is always included.",
  "Select {value0}": "Select {value0}",
  "Send": "Send",
  "Server (WHIP):": "Server (WHIP):",
  "Server:": "Server:",
  "Service:": "Service:",
  "Share your game and let friends join your Nova Rally lobby! No streaming software needed - just click and play.": "Share your game and let friends join your Nova Rally lobby! No streaming software needed - just click and play.",
  "Share your lobby link with friends or post it in Discord!": "Share your lobby link with friends or post it in Discord!",
  "Shield": "Shield",
  "Shield (3)": "Shield (3)",
  "Shield {goal} damage": "Shield {goal} damage",
  "Shielding": "Shielding",
  "Shields Used": "Shields Used",
  "Shocker": "Shocker",
  "Shovel": "Shovel",
  "Side": "Side",
  "Signed in with {value0}": "Signed in with {value0}",
  "Silly": "Silly",
  "Skin": "Skin",
  "Skins": "Skins",
  "Sky Fist": "Sky Fist",
  "Smooth on weak laptops, low bandwidth": "Smooth on weak laptops, low bandwidth",
  "Snake Eyes": "Snake Eyes",
  "Sound Wave": "Sound Wave",
  "Space": "Space",
  "Speed": "Speed",
  "Speed Demon - First place 10 times": "Speed Demon - First place 10 times",
  "Stardust": "Stardust",
  "Start Streaming": "Start Streaming",
  "Starting...": "Starting...",
  "Stats": "Stats",
  "Sticky Bombs": "Sticky Bombs",
  "Store": "Store",
  "Streak:": "Streak:",
  "Stream will auto-disconnect in {seconds} seconds due to inactivity": "Stream will auto-disconnect in {seconds} seconds due to inactivity",
  "Streams": "Streams",
  "Sunset": "Sunset",
  "Surprised": "Surprised",
  "Swap": "Swap",
  "Synthwave": "Synthwave",
  "Take control during the race to issue commands like speed boosts and ramming opponents.": "Take control during the race to issue commands like speed boosts and ramming opponents.",
  "Take {goal} damage": "Take {goal} damage",
  "Taunt": "Taunt",
  "Taxi": "Taxi",
  "Teal": "Teal",
  "Terms of Service": "Terms of Service",
  "The Array": "The Array",
  "The Bird": "The Bird",
  "The Compensator": "The Compensator",
  "The GOAT": "The GOAT",
  "The Knockout": "The Knockout",
  "The Oozer": "The Oozer",
  "The Phat One": "The Phat One",
  "The Piston": "The Piston",
  "The league \"{value0}\" has not started yet.": "The league \"{value0}\" has not started yet.",
  "Thermal": "Thermal",
  "Tidal Wave": "Tidal Wave",
  "To Play": "To Play",
  "Toggle Menu (-)": "Toggle Menu (-)",
  "Tools": "Tools",
  "Top Hat": "Top Hat",
  "Total": "Total",
  "Total Races: {value0}": "Total Races: {value0}",
  "Trail": "Trail",
  "Trophies": "Trophies",
  "Trophy": "Trophy",
  "Trophy Unlocked!": "Trophy Unlocked!",
  "Twitch": "Twitch",
  "Type a message...": "Type a message...",
  "Typhoon": "Typhoon",
  "Underglow": "Underglow",
  "Underglows": "Underglows",
  "Unknown": "Unknown",
  "Unmute": "Unmute",
  "Up to": "Up to",
  "Updating display name...": "Updating display name...",
  "Use OBS Studio for up to {value0} at 720p (vs 2.5 Mbps browser limit). Supports game capture, scenes, and overlays.": "Use OBS Studio for up to {value0} at 720p (vs 2.5 Mbps browser limit). Supports game capture, scenes, and overlays.",
  "User Avatar": "User Avatar",
  "Vehicles": "Vehicles",
  "Vine Grab": "Vine Grab",
  "W": "W",
  "Waiting for first race to start guessing...": "Waiting for first race to start guessing...",
  "Watch them race autonomously, driven by their unique stats.": "Watch them race autonomously, driven by their unique stats.",
  "Watermelon": "Watermelon",
  "Wax Trophy": "Wax Trophy",
  "Weekly Winner": "Weekly Winner",
  "Weight": "Weight",
  "Welcome to {value0}'s Lobby": "Welcome to {value0}'s Lobby",
  "Win 3 races - Completed!": "Win 3 races - Completed!",
  "Win Rate": "Win Rate",
  "Win a race": "Win a race",
  "Wolf Pack": "Wolf Pack",
  "Yellow": "Yellow",
  "You completed a quest!": "You completed a quest!",
  "You earned a new trophy!": "You earned a new trophy!",
  "You got BINGO! Tap to claim!": "You got BINGO! Tap to claim!",
  "You have a new notification": "You have a new notification",
  "You need to be logged in to host a game.": "You need to be logged in to host a game.",
  "You reached a milestone!": "You reached a milestone!",
  "You received a new item!": "You received a new item!",
  "You won with a column! Tap to spin!": "You won with a column! Tap to spin!",
  "You won with a diagonal!": "You won with a diagonal!",
  "You won with a diagonal! Tap to spin!": "You won with a diagonal! Tap to spin!",
  "You won with a row! Tap to spin!": "You won with a row! Tap to spin!",
  "You won with a {type}! Tap to spin!": "You won with a {type}! Tap to spin!",
  "YouTube": "YouTube",
  "Your lobby URL: www.novarally.io/lobby/{value0}": "Your lobby URL: www.novarally.io/lobby/{value0}",
  "avatar": "avatar",
  "pts": "pts",
  "s": "s",
  "{days}d ago": "{days}d ago",
  "{hours}h ago": "{hours}h ago",
  "{minutes}m ago": "{minutes}m ago",
  "{minutes}m {seconds}s": "{minutes}m {seconds}s",
  "{name} Leveled Up!": "{name} Leveled Up!",
  "{provider} account linked successfully.": "{provider} account linked successfully.",
  "{provider} account linked successfully. Previous profile name was released.": "{provider} account linked successfully. Previous profile name was released.",
  "{seconds}s": "{seconds}s",
  "{value0} 10 Races": "{value0} 10 Races",
  "{value0} 1280x720 (720p max)": "{value0} 1280x720 (720p max)",
  "{value0} 15 Races": "{value0} 15 Races",
  "{value0} 2 seconds": "{value0} 2 seconds",
  "{value0} 25 Races": "{value0} 25 Races",
  "{value0} 2500-6000 kbps": "{value0} 2500-6000 kbps",
  "{value0} 5 Races": "{value0} 5 Races",
  "{value0} 50 Races": "{value0} 50 Races",
  "{value0} Claimed": "{value0} Claimed",
  "{value0} Copy URL above": "{value0} Copy URL above",
  "{value0} Copy token above": "{value0} Copy token above",
  "{value0} LIVE": "{value0} LIVE",
  "{value0} Leaderboard": "{value0} Leaderboard",
  "{value0} Podiums": "{value0} Podiums",
  "{value0} Races": "{value0} Races",
  "{value0} Refresh": "{value0} Refresh",
  "{value0} Select the window you want to share. Viewers will see your stream in real-time with voice chat support.": "{value0} Select the window you want to share. Viewers will see your stream in real-time with voice chat support.",
  "{value0} Start Stream": "{value0} Start Stream",
  "{value0} Stop Stream": "{value0} Stop Stream",
  "{value0} WHIP": "{value0} WHIP",
  "{value0} Wins": "{value0} Wins",
  "{value0} XP": "{value0} XP",
  "{value0} avg": "{value0} avg",
  "{value0} avg pts": "{value0} avg pts",
  "{value0} races": "{value0} races",
  "{value0} wins": "{value0} wins",
  "{value0} x264 (veryfast) or AMD HW H.264": "{value0} x264 (veryfast) or AMD HW H.264",
  "{value0}'s Leaderboard": "{value0}'s Leaderboard",
  "{value0}LIVE": "{value0}LIVE",
  "{value0}Login with Discord": "{value0}Login with Discord",
  "{value0}Login with Google": "{value0}Login with Google",
  "{value0}Login with TikTok": "{value0}Login with TikTok",
  "{value0}Login with Twitter": "{value0}Login with Twitter",
  "{value0}Microphone": "{value0}Microphone",
  "{value0}Stream Settings": "{value0}Stream Settings",
  "{value0}  Login with Email": "{value0}  Login with Email",
  "{value0}  Login with Facebook": "{value0}  Login with Facebook",
  "{value0}  Login with Google": "{value0}  Login with Google",
  "{value0}  Login with Twitch": "{value0}  Login with Twitch",
  "{value0}  {value1}": "{value0}  {value1}",
  "{value0}✨{value1}Passenger Special": "{value0}✨{value1}Passenger Special",
  "{value0}🌟{value1}Driver Special": "{value0}🌟{value1}Driver Special",
  "{value0}🔰{value1}Ram": "{value0}🔰{value1}Ram",
  "{value0}🚀{value1}Boost": "{value0}🚀{value1}Boost",
  "{value0}🛑{value1}Brake": "{value0}🛑{value1}Brake",
  "{value0}🛡️{value1}Shield": "{value0}🛡️{value1}Shield",
  "← Back to Controller": "← Back to Controller",
  "↩ Go to Current Level": "↩ Go to Current Level",
  "⏱️ Fastest": "⏱️ Fastest",
  "⏳ Checking…": "⏳ Checking…",
  "▶ YOU ARE HERE": "▶ YOU ARE HERE",
  "☰ Menu": "☰ Menu",
  "⚠️ Unclaimed rewards will be lost!": "⚠️ Unclaimed rewards will be lost!",
  "⚡ Actions": "⚡ Actions",
  "⚡ Faster": "⚡ Faster",
  "⚡ Faster or Slower": "⚡ Faster or Slower",
  "⚡ Fastest Times": "⚡ Fastest Times",
  "✓ Correct!": "✓ Correct!",
  "✓ Linked": "✓ Linked",
  "✕ Stop Watching": "✕ Stop Watching",
  "✗ Wrong!": "✗ Wrong!",
  "⭐ Featured Streamers": "⭐ Featured Streamers",
  "🌐 All Time": "🌐 All Time",
  "🎁 Rewards": "🎁 Rewards",
  "🎉 Driver": "🎉 Driver",
  "🎉 Passenger": "🎉 Passenger",
  "🎙️ Voice Chat": "🎙️ Voice Chat",
  "🎤 Enable Voice": "🎤 Enable Voice",
  "🎮 New UI": "🎮 New UI",
  "🎮 Play Now": "🎮 Play Now",
  "🎮 Player-hosted live games": "🎮 Player-hosted live games",
  "🎮 What is Nova Rally?": "🎮 What is Nova Rally?",
  "🎲 Drawn ({value0})": "🎲 Drawn ({value0})",
  "🎺{value0}Horn": "🎺{value0}Horn",
  "🏁{value0}Join": "🏁{value0}Join",
  "🏆 Milestones are active all season with multiple reward levels": "🏆 Milestones are active all season with multiple reward levels",
  "🏆 Points": "🏆 Points",
  "🏆{value0}Season": "🏆{value0}Season",
  "🐢 Slower": "🐢 Slower",
  "👁️ Watch Stream ({value0} watching)": "👁️ Watch Stream ({value0} watching)",
  "👁️ {count} viewer": "👁️ {count} viewer",
  "👁️ {count} viewers": "👁️ {count} viewers",
  "👁️ {value0} viewer{value1}": "👁️ {value0} viewer{value1}",
  "👥 Favorite Duos": "👥 Favorite Duos",
  "👥 {value0} viewers": "👥 {value0} viewers",
  "👽 Meet the Drivers": "👽 Meet the Drivers",
  "💔 Damage Taken": "💔 Damage Taken",
  "💥 Damage Dealt": "💥 Damage Dealt",
  "💺 Top Passengers": "💺 Top Passengers",
  "💾 Apply Changes": "💾 Apply Changes",
  "📈 Performance": "📈 Performance",
  "🔄 Refresh": "🔄 Refresh",
  "🔄 Refresh Streams": "🔄 Refresh Streams",
  "🔊 Speaking...": "🔊 Speaking...",
  "🔒 Guess locked in! Waiting for race result...": "🔒 Guess locked in! Waiting for race result...",
  "🔒 Lv. {value0}": "🔒 Lv. {value0}",
  "🔔 Notifications {value0}": "🔔 Notifications {value0}",
  "🔗 Link Accounts": "🔗 Link Accounts",
  "🔥 Hot Streaks": "🔥 Hot Streaks",
  "🔰{value0}Ram": "🔰{value0}Ram",
  "🔴 LIVE · {value0} viewers": "🔴 LIVE · {value0} viewers",
  "🔴 {value0} Live · 👥 {value1} Viewers": "🔴 {value0} Live · 👥 {value1} Viewers",
  "🕹️ Game Controls": "🕹️ Game Controls",
  "😐{value0}Emote": "😐{value0}Emote",
  "🚀 Start Hosting": "🚀 Start Hosting",
  "🚀 Start Hosting as {value0}": "🚀 Start Hosting as {value0}",
  "🚀{value0}Boost": "🚀{value0}Boost",
  "🚗 3D View": "🚗 3D View",
  "🚗 Meet the Cars": "🚗 Meet the Cars",
  "🚗 Top Cars": "🚗 Top Cars",
  "🚗{value0}Car": "🚗{value0}Car",
  "🛑{value0}Brake": "🛑{value0}Brake",
  "🛞 Top Drivers": "🛞 Top Drivers",
  "🛡️ Damage Shielded": "🛡️ Damage Shielded",
  "🛡️{value0}Shield": "🛡️{value0}Shield",
  "🧑{value0}Drivers": "🧑{value0}Drivers",
  "🧪 Test Notification": "🧪 Test Notification"
} as const;

export type MessageKey = keyof typeof en;

export const ja: Record<MessageKey, string> = {
  " Car": " マシン",
  " Contests": " コンテスト",
  " Drivers": " ドライバー",
  " Join": " 参加する",
  " Menu": " メニュー",
  " Season": " シーズン",
  "21 unique drivers with different driving styles": "走り方も個性豊かな21人のドライバー",
  "6 Mbps": "6 Mbps",
  "A Free To Play casual racing game where you pick two aliens and a car.": "2人のエイリアンと1台のマシンを選んで楽しむ、無料のカジュアルレースゲームです。",
  "A quick surge of speed, but can be dangerous!": "一気に加速！ただし、危険も伴います。",
  "Abilities": "アビリティ",
  "Accel": "加速",
  "Actions": "アクション",
  "Adoring Fans": "熱狂的なファン",
  "Advanced: Stream via OBS": "詳細設定：OBSで配信",
  "After the first race, the leaderboard will be updated upon refresh.": "最初のレースが終了したら、更新するとランキングが表示されます。",
  "Airstrike": "空爆",
  "All Players ({value0})": "全プレイヤー（{value0}人）",
  "An error occurred": "エラーが発生しました",
  "An error occurred while updating display name.": "表示名の更新中にエラーが発生しました。",
  "Angry": "怒り",
  "Atomic": "アトミック",
  "Attack your opponents and knock them off the road!": "ライバルに体当たりして、コースから弾き飛ばしましょう！",
  "Avg Pos": "平均順位",
  "Awooga": "アウーガ",
  "BINGO!": "ビンゴ！",
  "BINGO! 🎰 Claim Prize": "ビンゴ！🎰 賞品を受け取る",
  "BOOST": "ブースト",
  "Battlepass Reward!": "バトルパス報酬！",
  "Be the first to host a game!": "最初のホストになりましょう！",
  "Beaky": "ビーキー",
  "Bearer Token:": "Bearerトークン：",
  "Best Time": "ベストタイム",
  "Best Win Streak": "最多連勝数",
  "Best quality, high bandwidth": "最高画質・通信量多め",
  "Bingo": "ビンゴ",
  "Biohazard": "バイオハザード",
  "Bitrate:": "ビットレート：",
  "Black Hole": "ブラックホール",
  "Blue": "青",
  "Blue Horse": "ブルーホース",
  "Blue Lightning": "青い稲妻",
  "Boards are created automatically when you participate": "参加すると、カードが自動で作成されます",
  "Boost": "ブースト",
  "Boost (1)": "ブースト（1）",
  "Boost 10 times": "ブーストを10回使う",
  "Boost Trail": "ブーストの軌跡",
  "Boost Trails": "ブーストの軌跡",
  "Boost {goal} times": "ブーストを{goal}回使う",
  "Booster": "ブースター",
  "Boosters": "ブースター",
  "Boosting": "ブースト",
  "Boosts Used": "ブースト使用回数",
  "Bottle Spray": "ボトルスプレー",
  "Bowling Ball": "ボウリングボール",
  "Brake": "ブレーキ",
  "Brake (4)": "ブレーキ（4）",
  "Brakes Used": "ブレーキ使用回数",
  "Break check into 10 cars": "ブレーキで10台のマシンを巻き込む",
  "Bugle": "ラッパ",
  "Bunny Hop": "バニーホップ",
  "CARS": "マシン",
  "Cancel": "キャンセル",
  "Candy Horn": "キャンディーホーン",
  "Car": "マシン",
  "Car Jump": "マシンジャンプ",
  "Celebration": "勝利ポーズ",
  "Celebrations": "勝利ポーズ",
  "Change Name": "名前を変更",
  "Characters": "キャラクター",
  "Chat": "チャット",
  "Check back later!": "また後でチェックしてください！",
  "Check for active stream": "配信中か確認",
  "Cherry Blossoms": "桜",
  "Choose from a selection of 10 vehicles": "10台のマシンから選べます",
  "Chrome": "クローム",
  "Circus Cannon": "サーカスキャノン",
  "Claim": "受け取る",
  "Claim all daily quests": "すべてのデイリークエストの報酬を受け取る",
  "Claiming reward...": "報酬を受け取り中…",
  "Click the button above and share your game window - it's that easy!": "上のボタンを押してゲーム画面を共有するだけで、簡単に始められます！",
  "Close": "閉じる",
  "Close notification": "通知を閉じる",
  "Codex": "図鑑",
  "Combos": "組み合わせ",
  "Complete a race to see your stats!": "レースを完走すると成績が表示されます！",
  "Complete races to see standings!": "レースを完走すると順位が表示されます！",
  "Complete the Twitch sign-in to finish linking.": "Twitchへのログインを完了して、アカウントを連携してください。",
  "Completing login, please wait...": "ログインを完了しています。しばらくお待ちください…",
  "Confused": "困惑",
  "Connected": "接続済み",
  "Connecting...": "接続中…",
  "Contests": "コンテスト",
  "Contests (0)": "コンテスト（0）",
  "Continue as Guest": "ゲストとして続ける",
  "Copy the settings above into OBS, then press Start Stream in OBS.": "上の設定をOBSにコピーし、OBSで「配信開始」を押してください。",
  "Create Your Lobby": "ロビーを作成",
  "Crying": "泣く",
  "Current": "現在",
  "Customise your vehicles with a variety of cosmetic upgrades!": "さまざまなカスタムアイテムでマシンの見た目を変えましょう！",
  "Customize Car": "マシンをカスタマイズ",
  "Customize Car (7)": "マシンをカスタマイズ（7）",
  "Customize Driver & Passenger": "ドライバーと同乗者をカスタマイズ",
  "Customize Drivers (8)": "ドライバーをカスタマイズ（8）",
  "Customize {value0}": "{value0}をカスタマイズ",
  "DRIVERS": "ドライバー",
  "Daily quests reset at {value0}{value1}": "デイリークエストのリセット時刻：{value0}{value1}",
  "Damage Dealt": "与えたダメージ",
  "Damage Shielded": "防いだダメージ",
  "Damage Taken": "受けたダメージ",
  "Dance": "ダンス",
  "Decal": "デカール",
  "Decals": "デカール",
  "Did Not Finish": "リタイア",
  "Disconnected due to inactivity": "操作がなかったため、接続が切れました",
  "Display name cannot be empty": "表示名を入力してください",
  "Do 1,000 damage to other cars": "他のマシンに1,000ダメージを与える",
  "Do 1000 damage": "1000ダメージを与える",
  "Do {goal} damage": "{goal}ダメージを与える",
  "Done": "完了",
  "Door": "ドア",
  "Drag to rotate": "ドラッグで回転",
  "Drift": "ドリフト",
  "Driver": "ドライバー",
  "Driver Radio": "ドライバー無線",
  "Driver Special (Q)": "ドライバーの特殊能力（Q）",
  "Driver {value0}": "ドライバー {value0}",
  "Drivers": "ドライバー",
  "Driving": "運転技術",
  "E": "E",
  "Earthquake": "地震",
  "Emote": "エモート",
  "Emote (E)": "エモート（E）",
  "Emotes": "エモート",
  "Enable your microphone to speak with others": "マイクを有効にすると、他の参加者と会話できます",
  "Encoder:": "エンコーダ：",
  "FREE": "無料",
  "Failed to connect to HD stream": "HD配信に接続できませんでした",
  "Failed to link account": "アカウントを連携できませんでした",
  "Failed to load car": "マシンを読み込めませんでした",
  "Failed to load leaderboard": "ランキングを読み込めませんでした",
  "Failed to start HD stream": "HD配信を開始できませんでした",
  "Failed to update display name. Please try again.": "表示名を更新できませんでした。もう一度お試しください。",
  "Fastest Race": "最速レース",
  "Fastest Time": "最速タイム",
  "Finish 100 races - Level 3 Complete!": "100レース完走 — レベル3達成！",
  "Finish Rate": "完走率",
  "Finish in 5 races": "5レースを完走する",
  "Finish {goal} races": "{goal}レースを完走する",
  "Fireball": "ファイアボール",
  "First X Races:": "集計する最初のレース数：",
  "First {value0} Races": "最初の{value0}レース",
  "Flaming Skull": "炎のドクロ",
  "Flex": "筋肉アピール",
  "Forest": "森林",
  "Galaxy": "銀河",
  "Galaxy Paint added to your inventory": "ギャラクシーペイントが所持アイテムに追加されました",
  "Garage": "ガレージ",
  "Generate OBS Settings": "OBSの設定を生成",
  "Ghost": "ゴースト",
  "Glow": "アンダーグロー",
  "Good quality, low bandwidth": "高画質・通信量少なめ",
  "Green": "緑",
  "Growth Potion": "巨大化ポーション",
  "Guess": "予想",
  "Guest username": "ゲスト名",
  "Handling": "操作性",
  "Happy": "喜び",
  "Hat": "帽子",
  "Hats": "帽子",
  "Health": "耐久力",
  "High quality": "高画質",
  "Higher Quality with OBS": "OBSで高画質配信",
  "Hold to Talk": "押している間だけ話す",
  "Hold {value0} to talk": "{value0}を押している間だけ話す",
  "Home": "ホーム",
  "Hood": "ボンネット",
  "Horn": "クラクション",
  "Horn (R)": "クラクション（R）",
  "Horns": "クラクション",
  "Horny": "ホーニー",
  "Host": "ホスト",
  "Host a Live Lobby": "ライブロビーをホスト",
  "How it works:": "遊び方：",
  "How to Play": "遊び方",
  "IVS WHIP supports max 720p. Set Output Resolution in Settings > Video. Requires OBS v30+.": "IVS WHIPは最大720pに対応しています。「設定」→「映像」で出力解像度を設定してください。OBS v30以降が必要です。",
  "Impulse": "インパルス",
  "Initializing...": "初期化中…",
  "Invite Players": "プレイヤーを招待",
  "Join": "参加する",
  "Join Race (6)": "レースに参加（6）",
  "Join a race to get your bingo board!": "レースに参加して、ビンゴカードを手に入れましょう！",
  "Just now": "たった今",
  "Ketchup & Mustard": "ケチャップ＆マスタード",
  "Keyframe Interval:": "キーフレーム間隔：",
  "Last Time:": "前回のタイム：",
  "Leaderboard": "ランキング",
  "League Not Started": "リーグは未開始です",
  "Leave": "退出",
  "Level {level} Unlocked!": "レベル{level}が解放されました！",
  "Level {level} reward is ready to claim!": "レベル{level}の報酬を受け取れます！",
  "Level {value0}": "レベル{value0}",
  "Link Twitch": "Twitchと連携",
  "Linking...": "連携中…",
  "Loaded Dice": "いかさまダイス",
  "Loading OBS settings...": "OBSの設定を読み込み中…",
  "Loading all-time stats...": "全期間の成績を読み込み中…",
  "Loading bingo...": "ビンゴを読み込み中…",
  "Loading car model...": "マシンのモデルを読み込み中…",
  "Loading car...": "マシンを読み込み中…",
  "Loading combo stats...": "組み合わせの成績を読み込み中…",
  "Loading leaderboard...": "ランキングを読み込み中…",
  "Loading profile...": "プロフィールを読み込み中…",
  "Loading...": "読み込み中…",
  "Lobbies": "ロビー",
  "Locusts": "イナゴの群れ",
  "Log In": "ログイン",
  "Logging in, please wait...": "ログイン中です。しばらくお待ちください…",
  "Login": "ログイン",
  "Login to Start Hosting": "ログインしてホストを開始",
  "Login with Twitch": "Twitchでログイン",
  "Logout": "ログアウト",
  "Lv {value0}": "Lv {value0}",
  "Lv. {value0}": "Lv. {value0}",
  "Lv.{value0} • {value1}/1000": "Lv.{value0} • {value1}/1000",
  "Mach 55": "マッハ55",
  "Magnet": "マグネット",
  "Mark all read": "すべて既読にする",
  "Matrix": "マトリックス",
  "Meow": "ニャー",
  "Microphone access denied. Check browser permissions to enable commentary.": "マイクの使用が許可されていません。実況するにはブラウザーの権限設定を確認してください。",
  "Microphone {value0}": "マイク{value0}",
  "Milestone Reached!": "マイルストーン達成！",
  "Milestones": "マイルストーン",
  "Monochrome": "モノクロ",
  "Monster": "モンスター",
  "Morale": "士気",
  "Most DNF": "リタイア最多",
  "Mute": "ミュート",
  "My Board": "自分のカード",
  "My Stats": "自分の成績",
  "Name": "名前",
  "Need 5+ races with same duo": "同じコンビで5レース以上の出場が必要です",
  "New Item!": "新しいアイテム！",
  "New season reward available - tap to claim!": "シーズン報酬を受け取れます。タップして受け取りましょう！",
  "No Changes": "変更なし",
  "No Microphone (system audio only)": "マイクなし（システム音声のみ）",
  "No commands queued": "待機中のコマンドはありません",
  "No duo data yet": "コンビのデータはまだありません",
  "No items in inventory": "所持アイテムはありません",
  "No leaderboard data yet": "ランキングのデータはまだありません",
  "No live lobbies right now": "現在、開催中のライブロビーはありません",
  "No messages yet": "メッセージはまだありません",
  "No microphones found": "マイクが見つかりません",
  "No notifications yet": "通知はまだありません",
  "No one is connected yet": "まだ誰も接続していません",
  "No one is currently streaming Nova Rally on Twitch.": "現在、TwitchでNova Rallyを配信している人はいません。",
  "No players have boards yet": "まだビンゴカードを持っているプレイヤーはいません",
  "No race data found for \"{value0}\"": "「{value0}」のレースデータが見つかりません",
  "No race results yet": "レース結果はまだありません",
  "No races on {value0} yet. Try \"All Time\"!": "{value0}でのレース記録はまだありません。「全期間」をお試しください！",
  "None": "なし",
  "Not connected to the network!": "ネットワークに接続されていません！",
  "Not linked": "未連携",
  "Notification": "通知",
  "Nova Ballet": "ノヴァ・バレエ",
  "Nova Rally": "Nova Rally",
  "Now level {level}!": "レベル{level}になりました！",
  "OBS Setup (v30+):": "OBSの設定（v30以降）：",
  "OFF": "オフ",
  "OK": "OK",
  "ON": "オン",
  "Offline": "オフライン",
  "Online": "オンライン",
  "Ooze Slime": "スライム",
  "Output Resolution:": "出力解像度：",
  "Overall Leaderboard": "総合ランキング",
  "PTT {value0}": "プッシュ・トゥ・トーク {value0}",
  "Paint": "ペイント",
  "Participants ({value0})": "参加者（{value0}人）",
  "Party Hat": "パーティーハット",
  "Passenger": "同乗者",
  "Passenger Special (W)": "同乗者の特殊能力（W）",
  "Phoenix": "フェニックス",
  "Play": "プレイ",
  "Play Now": "今すぐプレイ",
  "Play on": "対応プラットフォーム",
  "Players": "人でプレイ",
  "Players join and use the game controls to compete in your races!": "参加したプレイヤーは、ゲームの操作ボタンを使ってレースで競い合えます！",
  "Please log in before linking accounts.": "アカウントを連携する前にログインしてください。",
  "Please log in to see your stats": "ログインすると自分の成績を確認できます",
  "Please log in to start a stream": "配信を開始するにはログインしてください",
  "Please login to participate": "ログインして参加してください",
  "Please login to play": "ログインしてプレイしてください",
  "Please login to play.": "ログインしてプレイしてください。",
  "Podium 3 times": "3回表彰台に上がる",
  "Podium Rate": "表彰台率",
  "Points": "ポイント",
  "Polygon": "ポリゴン",
  "Pre-Alpha Tester": "プレアルファテスター",
  "Privacy Policy": "プライバシーポリシー",
  "Processing login, please wait...": "ログイン処理中です。しばらくお待ちください…",
  "Protect yourself from damage for a few seconds": "数秒間、ダメージから身を守ります",
  "Purple": "紫",
  "Q": "Q",
  "Quality": "画質",
  "Quest Complete!": "クエスト達成！",
  "Quests": "クエスト",
  "R": "R",
  "RAM": "体当たり",
  "Race Finishes (Last {value0})": "直近{value0}レースの順位",
  "Race Together!": "みんなでレース！",
  "Race with {car} 3x": "{car}で3回レースに出場する",
  "Race with {driver} 5x": "{driver}で5回レースに出場する",
  "Race {value0}": "レース{value0}",
  "Races": "レース",
  "Ram": "体当たり",
  "Ram (2)": "体当たり（2）",
  "Ram into 10 cars": "10台のマシンに体当たりする",
  "Ram into {goal} opponents": "{goal}人のライバルに体当たりする",
  "Ramming": "体当たり",
  "Rams": "体当たりパーツ",
  "Rams Used": "体当たり使用回数",
  "Random": "ランダム",
  "Rank": "順位",
  "Re-authenticating, please wait...": "再認証中です。しばらくお待ちください…",
  "Reach Level {value0}": "レベル{value0}に到達",
  "Reach level {value0} to unlock more rewards.": "レベル{value0}に到達すると、さらに報酬が解放されます。",
  "Red": "赤",
  "Refresh season data": "シーズンデータを更新",
  "Refresh stream status": "配信状況を更新",
  "Refreshing profile...": "プロフィールを更新中…",
  "Refreshing...": "更新中…",
  "Regen": "再生",
  "Relink Twitch": "Twitchを再連携",
  "Reward": "報酬",
  "Rewards": "報酬",
  "SHIELD": "シールド",
  "Sammy Baffled": "困り顔のSammy",
  "Save": "保存",
  "Screen Share": "画面共有",
  "Season": "シーズン",
  "Season 2 ends in {value0}d {value1}h": "シーズン2終了まであと{value0}日{value1}時間",
  "Season Pass (9)": "シーズンパス（9）",
  "Season Points": "シーズンポイント",
  "Select Car": "マシンを選択",
  "Select Driver": "ドライバーを選択",
  "Select Passenger": "同乗者を選択",
  "Select a League": "リーグを選択",
  "Select your mic for voice commentary. System audio from the shared window is always included.": "実況に使うマイクを選んでください。共有ウィンドウのシステム音声は常に含まれます。",
  "Select {value0}": "{value0}を選択",
  "Send": "送信",
  "Server (WHIP):": "サーバー（WHIP）：",
  "Server:": "サーバー：",
  "Service:": "サービス：",
  "Share your game and let friends join your Nova Rally lobby! No streaming software needed - just click and play.": "ゲーム画面を共有して、友達をNova Rallyのロビーに招待しましょう！配信ソフトは不要。クリックするだけでプレイできます。",
  "Share your lobby link with friends or post it in Discord!": "ロビーのリンクを友達に送ったり、Discordに投稿したりしましょう！",
  "Shield": "シールド",
  "Shield (3)": "シールド（3）",
  "Shield {goal} damage": "シールドで{goal}ダメージを防ぐ",
  "Shielding": "シールド",
  "Shields Used": "シールド使用回数",
  "Shocker": "ショッカー",
  "Shovel": "シャベル",
  "Side": "サイド",
  "Signed in with {value0}": "{value0}でログイン中",
  "Silly": "おふざけ",
  "Skin": "スキン",
  "Skins": "スキン",
  "Sky Fist": "スカイフィスト",
  "Smooth on weak laptops, low bandwidth": "低スペックPCでも滑らか・通信量少なめ",
  "Snake Eyes": "スネークアイズ",
  "Sound Wave": "サウンドウェーブ",
  "Space": "スペース",
  "Speed": "速度",
  "Speed Demon - First place 10 times": "スピードデーモン — 1位を10回達成",
  "Stardust": "星くず",
  "Start Streaming": "配信を開始",
  "Starting...": "開始中…",
  "Stats": "成績",
  "Sticky Bombs": "粘着爆弾",
  "Store": "ストア",
  "Streak:": "連続正解：",
  "Stream will auto-disconnect in {seconds} seconds due to inactivity": "操作がないため、あと{seconds}秒で配信が自動的に切断されます",
  "Streams": "配信",
  "Sunset": "夕焼け",
  "Surprised": "驚き",
  "Swap": "入れ替え",
  "Synthwave": "シンセウェーブ",
  "Take control during the race to issue commands like speed boosts and ramming opponents.": "レース中にコマンドを出して、ブーストで加速したり、ライバルに体当たりしたりできます。",
  "Take {goal} damage": "{goal}ダメージを受ける",
  "Taunt": "挑発",
  "Taxi": "タクシー",
  "Teal": "青緑",
  "Terms of Service": "利用規約",
  "The Array": "アレイ",
  "The Bird": "バード",
  "The Compensator": "コンペンセーター",
  "The GOAT": "ゴート",
  "The Knockout": "ノックアウト",
  "The Oozer": "ウーザー",
  "The Phat One": "ファット・ワン",
  "The Piston": "ピストン",
  "The league \"{value0}\" has not started yet.": "リーグ「{value0}」はまだ始まっていません。",
  "Thermal": "サーマル",
  "Tidal Wave": "大波",
  "To Play": "でプレイ",
  "Toggle Menu (-)": "メニューの表示切替（-）",
  "Tools": "ツール",
  "Top Hat": "シルクハット",
  "Total": "合計",
  "Total Races: {value0}": "合計レース数：{value0}",
  "Trail": "軌跡",
  "Trophies": "トロフィー",
  "Trophy": "トロフィー",
  "Trophy Unlocked!": "トロフィー獲得！",
  "Twitch": "Twitch",
  "Type a message...": "メッセージを入力…",
  "Typhoon": "タイフーン",
  "Underglow": "アンダーグロー",
  "Underglows": "アンダーグロー",
  "Unknown": "不明",
  "Unmute": "ミュート解除",
  "Up to": "最大",
  "Updating display name...": "表示名を更新中…",
  "Use OBS Studio for up to {value0} at 720p (vs 2.5 Mbps browser limit). Supports game capture, scenes, and overlays.": "OBS Studioなら720pで最大{value0}の配信が可能です（ブラウザーでは最大2.5 Mbps）。ゲームキャプチャ、シーン、オーバーレイに対応しています。",
  "User Avatar": "ユーザーのアバター",
  "Vehicles": "マシン",
  "Vine Grab": "つるの拘束",
  "W": "W",
  "Waiting for first race to start guessing...": "最初のレースが終わると予想できます…",
  "Watch them race autonomously, driven by their unique stats.": "それぞれの能力を活かして自動で走るレースを観戦しましょう。",
  "Watermelon": "スイカ",
  "Wax Trophy": "WAXトロフィー",
  "Weekly Winner": "週間優勝者",
  "Weight": "重量",
  "Welcome to {value0}'s Lobby": "{value0}のロビーへようこそ",
  "Win 3 races - Completed!": "レースで3回優勝 — 達成！",
  "Win Rate": "勝率",
  "Win a race": "レースで優勝する",
  "Wolf Pack": "ウルフパック",
  "Yellow": "黄",
  "You completed a quest!": "クエストを達成しました！",
  "You earned a new trophy!": "新しいトロフィーを獲得しました！",
  "You got BINGO! Tap to claim!": "ビンゴ達成！タップして受け取る！",
  "You have a new notification": "新しい通知があります",
  "You need to be logged in to host a game.": "ゲームをホストするにはログインが必要です。",
  "You reached a milestone!": "マイルストーンを達成しました！",
  "You received a new item!": "新しいアイテムを受け取りました！",
  "You won with a column! Tap to spin!": "縦の列でビンゴ達成！タップしてスピン！",
  "You won with a diagonal!": "斜めの列でビンゴ達成！",
  "You won with a diagonal! Tap to spin!": "斜めの列でビンゴ達成！タップしてスピン！",
  "You won with a row! Tap to spin!": "横の列でビンゴ達成！タップしてスピン！",
  "You won with a {type}! Tap to spin!": "{type}でビンゴ達成！タップしてスピン！",
  "YouTube": "YouTube",
  "Your lobby URL: www.novarally.io/lobby/{value0}": "ロビーのURL：www.novarally.io/lobby/{value0}",
  "avatar": "アバター",
  "pts": "ポイント",
  "s": "s",
  "{days}d ago": "{days}日前",
  "{hours}h ago": "{hours}時間前",
  "{minutes}m ago": "{minutes}分前",
  "{minutes}m {seconds}s": "{minutes}分{seconds}秒",
  "{name} Leveled Up!": "{name}がレベルアップ！",
  "{provider} account linked successfully.": "{provider}アカウントを連携しました。",
  "{provider} account linked successfully. Previous profile name was released.": "{provider}アカウントを連携しました。以前のプロフィール名が解放されました。",
  "{seconds}s": "{seconds}秒",
  "{value0} 10 Races": "{value0} 10レース",
  "{value0} 1280x720 (720p max)": "{value0} 1280×720（最大720p）",
  "{value0} 15 Races": "{value0} 15レース",
  "{value0} 2 seconds": "{value0} 2秒",
  "{value0} 25 Races": "{value0} 25レース",
  "{value0} 2500-6000 kbps": "{value0} 2500～6000 kbps",
  "{value0} 5 Races": "{value0} 5レース",
  "{value0} 50 Races": "{value0} 50レース",
  "{value0} Claimed": "{value0} 受け取り済み",
  "{value0} Copy URL above": "{value0} 上のURLをコピー",
  "{value0} Copy token above": "{value0} 上のトークンをコピー",
  "{value0} LIVE": "{value0} 配信中",
  "{value0} Leaderboard": "{value0} ランキング",
  "{value0} Podiums": "表彰台 {value0}回",
  "{value0} Races": "{value0}レース",
  "{value0} Refresh": "{value0} 更新",
  "{value0} Select the window you want to share. Viewers will see your stream in real-time with voice chat support.": "{value0} 共有するウィンドウを選んでください。視聴者はリアルタイムで配信を視聴でき、ボイスチャットも利用できます。",
  "{value0} Start Stream": "{value0} 配信を開始",
  "{value0} Stop Stream": "{value0} 配信を停止",
  "{value0} WHIP": "{value0} WHIP",
  "{value0} Wins": "優勝 {value0}回",
  "{value0} XP": "{value0} XP",
  "{value0} avg": "平均 {value0}",
  "{value0} avg pts": "平均 {value0}ポイント",
  "{value0} races": "{value0}レース",
  "{value0} wins": "優勝 {value0}回",
  "{value0} x264 (veryfast) or AMD HW H.264": "{value0} x264（veryfast）またはAMD HW H.264",
  "{value0}'s Leaderboard": "{value0}のランキング",
  "{value0}LIVE": "{value0}配信中",
  "{value0}Login with Discord": "{value0}Discordでログイン",
  "{value0}Login with Google": "{value0}Googleでログイン",
  "{value0}Login with TikTok": "{value0}TikTokでログイン",
  "{value0}Login with Twitter": "{value0}Twitterでログイン",
  "{value0}Microphone": "{value0}マイク",
  "{value0}Stream Settings": "{value0}配信設定",
  "{value0}  Login with Email": "{value0}  メールでログイン",
  "{value0}  Login with Facebook": "{value0}  Facebookでログイン",
  "{value0}  Login with Google": "{value0}  Googleでログイン",
  "{value0}  Login with Twitch": "{value0}  Twitchでログイン",
  "{value0}  {value1}": "{value0}  {value1}",
  "{value0}✨{value1}Passenger Special": "{value0}✨{value1}同乗者の特殊能力",
  "{value0}🌟{value1}Driver Special": "{value0}🌟{value1}ドライバーの特殊能力",
  "{value0}🔰{value1}Ram": "{value0}🔰{value1}体当たり",
  "{value0}🚀{value1}Boost": "{value0}🚀{value1}ブースト",
  "{value0}🛑{value1}Brake": "{value0}🛑{value1}ブレーキ",
  "{value0}🛡️{value1}Shield": "{value0}🛡️{value1}シールド",
  "← Back to Controller": "← 操作画面に戻る",
  "↩ Go to Current Level": "↩ 現在のレベルへ",
  "⏱️ Fastest": "⏱️ 最速",
  "⏳ Checking…": "⏳ 確認中…",
  "▶ YOU ARE HERE": "▶ 現在のレベル",
  "☰ Menu": "☰ メニュー",
  "⚠️ Unclaimed rewards will be lost!": "⚠️ 未受け取りの報酬は失われます！",
  "⚡ Actions": "⚡ アクション",
  "⚡ Faster": "⚡ 速くなる",
  "⚡ Faster or Slower": "⚡ 速くなる？遅くなる？",
  "⚡ Fastest Times": "⚡ 最速タイム",
  "✓ Correct!": "✓ 正解！",
  "✓ Linked": "✓ 連携済み",
  "✕ Stop Watching": "✕ 視聴を終了",
  "✗ Wrong!": "✗ 不正解！",
  "⭐ Featured Streamers": "⭐ 注目の配信者",
  "🌐 All Time": "🌐 全期間",
  "🎁 Rewards": "🎁 報酬",
  "🎉 Driver": "🎉 ドライバー",
  "🎉 Passenger": "🎉 同乗者",
  "🎙️ Voice Chat": "🎙️ ボイスチャット",
  "🎤 Enable Voice": "🎤 音声を有効にする",
  "🎮 New UI": "🎮 新しい操作画面",
  "🎮 Play Now": "🎮 今すぐプレイ",
  "🎮 Player-hosted live games": "🎮 プレイヤーが開催中のゲーム",
  "🎮 What is Nova Rally?": "🎮 Nova Rallyとは？",
  "🎲 Drawn ({value0})": "🎲 抽選済み（{value0}）",
  "🎺{value0}Horn": "🎺{value0}クラクション",
  "🏁{value0}Join": "🏁{value0}参加する",
  "🏆 Milestones are active all season with multiple reward levels": "🏆 マイルストーンはシーズンを通して有効で、複数段階の報酬があります",
  "🏆 Points": "🏆 ポイント",
  "🏆{value0}Season": "🏆{value0}シーズン",
  "🐢 Slower": "🐢 遅くなる",
  "👁️ Watch Stream ({value0} watching)": "👁️ 配信を見る（{value0}人が視聴中）",
  "👁️ {count} viewer": "👁️ 視聴者 {count}人",
  "👁️ {count} viewers": "👁️ 視聴者 {count}人",
  "👁️ {value0} viewer{value1}": "👁️ 視聴者 {value0}人{value1}",
  "👥 Favorite Duos": "👥 お気に入りのコンビ",
  "👥 {value0} viewers": "👥 視聴者 {value0}人",
  "👽 Meet the Drivers": "👽 ドライバー紹介",
  "💔 Damage Taken": "💔 受けたダメージ",
  "💥 Damage Dealt": "💥 与えたダメージ",
  "💺 Top Passengers": "💺 同乗者ランキング",
  "💾 Apply Changes": "💾 変更を適用",
  "📈 Performance": "📈 成績",
  "🔄 Refresh": "🔄 更新",
  "🔄 Refresh Streams": "🔄 配信一覧を更新",
  "🔊 Speaking...": "🔊 発話中…",
  "🔒 Guess locked in! Waiting for race result...": "🔒 予想が確定しました！レース結果を待っています…",
  "🔒 Lv. {value0}": "🔒 Lv. {value0}",
  "🔔 Notifications {value0}": "🔔 通知 {value0}",
  "🔗 Link Accounts": "🔗 アカウント連携",
  "🔥 Hot Streaks": "🔥 連続正解ランキング",
  "🔰{value0}Ram": "🔰{value0}体当たり",
  "🔴 LIVE · {value0} viewers": "🔴 配信中 · 視聴者 {value0}人",
  "🔴 {value0} Live · 👥 {value1} Viewers": "🔴 {value0}件が配信中 · 👥 視聴者 {value1}人",
  "🕹️ Game Controls": "🕹️ ゲームの操作",
  "😐{value0}Emote": "😐{value0}エモート",
  "🚀 Start Hosting": "🚀 ホストを開始",
  "🚀 Start Hosting as {value0}": "🚀 {value0}としてホストを開始",
  "🚀{value0}Boost": "🚀{value0}ブースト",
  "🚗 3D View": "🚗 3D表示",
  "🚗 Meet the Cars": "🚗 マシン紹介",
  "🚗 Top Cars": "🚗 マシンランキング",
  "🚗{value0}Car": "🚗{value0}マシン",
  "🛑{value0}Brake": "🛑{value0}ブレーキ",
  "🛞 Top Drivers": "🛞 ドライバーランキング",
  "🛡️ Damage Shielded": "🛡️ 防いだダメージ",
  "🛡️{value0}Shield": "🛡️{value0}シールド",
  "🧑{value0}Drivers": "🧑{value0}ドライバー",
  "🧪 Test Notification": "🧪 通知をテスト"
};
